type DefaultVideos = {
  selectStory: string
  startVideoId: string
  startOfSession: string
  menuVideoId: string
  menu: string
}

const Videos: DefaultVideos = {
  selectStory: '/videos/select_story_on_touchinterface.mp4',
  startVideoId: 'startVideo',
  startOfSession: '/videos/intro_guide_animation.mp4',
  menuVideoId: 'menuVideo',
  menu: '/videos/selection_guide_illustrated.mp4',
};

export default Videos;
